import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/docs/node_modules/gatsby-theme-docz/src/base/Layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h1 {...{
      "id": "whats-this"
    }}>{`What's this`}</h1>
    <p>{`Collection of hooks that we re-use at Jam3`}</p>
    <h1 {...{
      "id": "why"
    }}>{`Why?`}</h1>
    <p>{`Since the React landscape is changing with the introduction of hooks
and the "deprecation" of classes is useful for us to keep a collection
of hooks so we can share functionality between projects.`}</p>
    <p>{`You could face 3 cases`}</p>
    <ol>
      <li parentName="ol">{`The functionality that you need is already here so just `}<inlineCode parentName="li">{`npm install`}</inlineCode></li>
      <li parentName="ol">{`There is some missing functionality so you want to make the hook
dynamic to multiple cases well open a PR`}</li>
      <li parentName="ol">{`Your use case is too specific, just copy and paste the hook and adapt it these way at least you're not starting from 0 and with best practices`}</li>
    </ol>
    <h2 {...{
      "id": "install"
    }}>{`Install`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-bash"
      }}>{`npm install react-hooks-lab
yarn add react-hooks-lab
`}</code></pre>
    <h2 {...{
      "id": "usage"
    }}>{`Usage`}</h2>
    <pre><code parentName="pre" {...{
        "className": "language-jsx"
      }}>{`// Import depending what you need it will tree-shake the modules
import { useIntersectionObserver } from "react-hooks-lab";
import { useMousePosition } from "react-hooks-lab";
import { useOnHover } from "react-hooks-lab";
import { useScrollDirection } from "react-hooks-lab";
import { useScrollProgress } from "react-hooks-lab";
import { useScrollToTop } from "react-hooks-lab";
import { useWindowSize } from "react-hooks-lab";
`}</code></pre>
    <p>{`For more information, please refer to `}<a parentName="p" {...{
        "href": "https://react-hooks-lab.netlify.com/"
      }}>{`Usage`}</a>{` in our documentation.`}</p>
    <h2 {...{
      "id": "contributing"
    }}>{`Contributing`}</h2>
    <p>{`Please make sure to read the `}<a parentName="p" {...{
        "href": "CONTRIBUTING.md"
      }}>{`contributing guide`}</a>{` before making a pull request.`}</p>
    <h2 {...{
      "id": "changelog"
    }}>{`Changelog`}</h2>
    <p>{`Detailed changes for each release are documented in the `}<a parentName="p" {...{
        "href": "CHANGELOG.md"
      }}>{`release notes`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      